module.exports = __webpack_public_path__ + "img/Group 6826@2x.989fc959.png";